import {Observable} from "rxjs";

export class ObservableQueueElement {
  public observable: Observable<any> = new Observable<any>();
  public callback: Function = () => {
  };
  public callbackError: Function = () => {
  };
  public callbackComplete: Function = () => {
  };
  public successIndicator: boolean = false;
}
